import { IndexListResponse } from "@/api/agendaConfiguration";
import { Avatar, Button, Card, Divider, Flex, Group, Select, Stack, Text, Title, useMantineColorScheme } from "@mantine/core";
import classes from "@/pages/saveBookingPage.module.css";
import { useMediaQuery } from "@mantine/hooks";
import { User } from "@/api/users";
import { LinkifyText } from "../LinkifyText/LinkifyText";
import { useCallback, useEffect, useMemo, useState } from "react";
import { IconAddressBook, IconArrowNarrowRight, IconCalendarTime, IconCash, IconClockHour9 } from "@tabler/icons-react";
import { secondsToTimeFormat } from "@/utils/availability";

interface SaveBookingChooseTypeProps {
  listAgendaConfs: IndexListResponse[];
  localUser: User;
  selectedAgId: number;
  setSelectedAgId: (value: number) => void;
  nextStep: () => void;
}

export const SaveBookingChooseType = ({listAgendaConfs, localUser, selectedAgId, setSelectedAgId, nextStep}: SaveBookingChooseTypeProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  const setListAgendaConfigurationsToData = useCallback(() => {
    if (!listAgendaConfs) return [];
    return listAgendaConfs.map(row => {
      return {
        label: row.name, value: row.id.toString()
      }
    })
  }, [listAgendaConfs]);

  const [selectedAgenda, setSelectedAgenda] = useState<IndexListResponse | undefined>();
  useEffect(() => {
    setSelectedAgenda(() => {
      const filtered = listAgendaConfs.filter(ag => ag.id === selectedAgId);
      if (filtered.length > 0) return filtered[0];
      return undefined;
    });
  }, [listAgendaConfs, selectedAgId]);

  return (
    <Card 
      shadow="sm" padding="lg" radius="md" withBorder 
      style={{margin: "auto", minHeight: "400px", display: "flex", flexDirection: "row", justifyContent: "center", gap: "24px", width: "fit-content"}}
    >
      <Stack style={{width: "300px"}} justify="center" align="center">
        <Avatar
          src={localUser.picture}
          alt={localUser.name}
          size={150}
          style={{ marginBottom: '15px', objectFit: 'cover' }}
        />
        <Title order={3}>{localUser.name}</Title>
        <Text
          style={{
            textAlign: 'left',
            width: "100%",
            whiteSpace: 'pre-line',
            wordBreak: 'break-word',
          }}
          size="sm"
        >
          <LinkifyText text={localUser?.description || ''} />
        </Text>
      </Stack>

      <Divider orientation="vertical"/>

      <Stack style={{width: "300px"}} align="center">
        <Title order={4}>{"Tipo de sesión"}</Title>
        <Select 
          style={{width: "100%"}}
          size="md"
          data={[ {label: "Seleccione un tipo de sesión", value: "0"}, ...setListAgendaConfigurationsToData()]} 
          value={selectedAgId.toString()} 
          onChange={(value) => setSelectedAgId(parseInt(value || ""))}
          leftSection={<IconCalendarTime size={20}/>}
        />
        <Flex gap={"sm"} align={"center"} justify={(selectedAgenda?.showPrice === undefined || selectedAgenda?.showPrice) ? 'space-between' : 'center'}>
          <Flex gap={"4"} align={"center"} >
            <IconClockHour9 size={18} />
            <Text style={{ fontWeight: 'bold', lineHeight: '1' }}>
              {selectedAgenda?.sessionDuration ? secondsToTimeFormat(selectedAgenda?.sessionDuration) : "---"}
            </Text>
          </Flex>
          {(selectedAgenda?.showPrice === undefined || selectedAgenda?.showPrice) && (
            <Flex gap={"4"} align={"center"}>
              <IconCash size={22} />
              <Text style={{ fontWeight: 'bold', lineHeight: '1' }}>
                {`$${selectedAgenda?.paymentAmount ?? "---"} ${selectedAgenda?.paymentCurrency ?? ""}`}
              </Text>
            </Flex>
          )}
        </Flex>
        <Text
          style={{
            textAlign: 'left',
            width: "100%",
            whiteSpace: 'pre-line',
            wordBreak: 'break-word',
          }}
          size="sm"
        >
          <LinkifyText text={selectedAgenda?.details || ''} />
        </Text>
        <Flex style={{marginTop: "auto"}}>
          <Button disabled={!selectedAgId} onClick={() => {
            if (selectedAgId) nextStep()
          }}>Siguiente <IconArrowNarrowRight size={20} /></Button>
        </Flex>
      </Stack>
    </Card>
  )
}